import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";

const FloorWiseTenantView = ({
  floorWiseTenants,
  isExpandable = true,
  floors,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Floor Number",
        key: "floorId",
        isRequired: true,
        renderField: (value) =>
          floors.find(({ id }) => id === value)?.name ?? "-",
      },
      {
        name: "Name",
        key: "name",
        isRequired: true,
      },
      {
        name: "Name of Responsible Person",
        key: "nameOfResponsiblePerson",
        isRequired: true,
      },
      {
        name: "Designation",
        key: "designation",
        isRequired: true,
      },
      {
        name: "Mobile Number",
        key: "mobileNumber",
        isRequired: true,
      },
      {
        name: "Email",
        key: "email",
        isRequired: true,
      },
    ],
    [floors]
  );

  return (
    <>
      <Collapse title="Floor Wise Tenant Details" isExpandable={isExpandable}>
        {floorWiseTenants.map((tenant, index) => (
          <Fragment key={tenant.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Tenant") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(tenant, key, "");

                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(tenant, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

FloorWiseTenantView.propTypes = {
  floorWiseTenants: PropTypes.object,
  isExpandable: PropTypes.bool,
  floors: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(FloorWiseTenantView);
